export default __webpack_public_path__ + "static/media/pop5.82257002.jpg";